import React from 'react';
import './Mpseriesphone.css';
import Reqprodcte from "../../../components/Reqprodcte";

import phonecaseImg from '../../../imgs/mpseries.webp';

const Mpseriesphone = () => {
  return (
    <div className="Mpseriesph-container">
      <div className="mpseri-card">
        <h2>Phone Case Injection Molding Machine</h2>
        <h3>MP SERIES</h3>
        <p>
          Powerjet MP series Phone Case Injection Molding Machine specialized for mobile phone cases and other accessories.
          Products are mainly manufactured using PC, Elastomers, and other raw materials.
        </p>
        <p>
          MP series focuses on the product features which are lightweight, high precision, and difficult to shape.
        </p>
        <ul>
          <li><strong>Clamping Force:</strong> 138 Ton</li>
          <li><strong>Shot Weight (PS):</strong> 88 / 115 g</li>
          <li><strong>Applications:</strong> Phone Cases</li>
        </ul>
        <div className='stnd'>
          <Reqprodcte />
        </div>          </div>

      {/* Image Card */}
      <div className="Mpserie-card"data-aos="fade-down">
        <img src={phonecaseImg} alt="Phone Case Injection Molding Machine" />
      </div>
    </div>
  );
};

export default Mpseriesphone;
